module.exports = __webpack_public_path__ + "media/Casino slot machine tone - winning count - mechanical and electronic spinning tone 4.22a80113.mp3";